import { render, staticRenderFns } from "./ConversationParticipant.vue?vue&type=template&id=0b5ecd03&scoped=true&"
import script from "./ConversationParticipant.vue?vue&type=script&lang=js&"
export * from "./ConversationParticipant.vue?vue&type=script&lang=js&"
import style0 from "./ConversationParticipant.vue?vue&type=style&index=0&id=0b5ecd03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5ecd03",
  null
  
)

export default component.exports